export const API_URL = '/api';

export const fetchWithAuth = (url, options = {}) => {
    const userStr = sessionStorage.getItem('user');
    if (!userStr) {
        window.location.href = '/'; 
        return Promise.reject(new Error("User not authenticated."));
    }

    const user = JSON.parse(userStr);
    const headers = {
        'Content-Type': 'application/json',
        'X-User-Id': user._id,
        'X-User-Email': user.email,
        ...options.headers,
    };

    if (options.body && typeof options.body !== 'string') {
        options.body = JSON.stringify(options.body);
    }

    return fetch(url, { ...options, headers });
};
